<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :hide-overlay="!dialog"
      @keydown.esc="dialog = false"
      :fullscreen="is_mobile"
      :scrollable="is_mobile"
      width="500"
      overlay-opacity="50"
      overlay-color="#ffffff"
      content-class="default-dialog"
    >
      <template v-slot:activator="{}">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.stop="dialog = true"
              icon
            >
              <v-icon>mdi-database-search</v-icon>
            </v-btn>
          </template>
          <span>{{ lang.global.filters }}</span>
        </v-tooltip>
        <v-divider
          inset
          vertical
        ></v-divider>
      </template>

      <v-card v-if="dialog">
        <v-card-title class="dialog-title">
          <span class="headline">
            <v-icon class="toolbar-icon">mdi-database-search</v-icon>
            {{ lang.global.filters }}
          </span>
          <v-spacer></v-spacer>
          <v-icon class="dialog-close-btn" @click="dialog = false">mdi-close</v-icon>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-container
            v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
            class="overflow-y-auto dialog-scrollbar"
            style="max-height: 350px; padding: 0px !important;"
          >
            <div class="filters-content">
              <v-row justify="center">
                <v-expansion-panels flat>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-calendar</v-icon>
                        <span>{{ lang.historic.filters.date_range.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-daterange
                        v-model="filters.date"
                        :presets="presets"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-webpack</v-icon>
                        <span>{{ lang.historic.filters.type.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-select
                        v-model="filters.type"
                        :items="get_global.defaults.options.financial.cashflow.types"
                        :label="lang.historic.filters.type.title"
                        :clearable="true"
                        item-text="title"
                        item-value="id"
                        clear-icon="mdi-broom"
                        single-line
                        filled
                        attach
                        hide-details
                      ></v-select>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="!(filters.type === 2)">
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-cash-multiple</v-icon>
                        <span>{{ lang.historic.filters.payment.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-select
                        v-model="filters.payment"
                        :items="get_global.defaults.options.financial.cashflow.methods"
                        :label="lang.historic.filters.payment.title"
                        :clearable="true"
                        item-text="title"
                        item-value="id"
                        clear-icon="mdi-broom"
                        multiple
                        chips
                        deletable-chips
                        filled
                        attach
                        hide-details
                      ></v-select>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="!(filters.type === 1)">
                    <v-expansion-panel-header class="justify-self-start" disable-icon-rotate>
                      <div>
                        <v-icon medium left>mdi-format-list-text</v-icon>
                        <span>{{ lang.historic.filters.categories.title }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-select
                        v-model="filters.categories"
                        :items="get_global.defaults.options.financial.cashflow.categories"
                        :label="lang.historic.filters.categories.title"
                        :clearable="true"
                        item-text="title"
                        item-value="id"
                        clear-icon="mdi-broom"
                        multiple
                        chips
                        deletable-chips
                        filled
                        attach
                        hide-details
                      ></v-select>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-row>
            </div>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click.stop="reset()"
          >
            {{ lang.historic.filters.reset }}
          </v-btn>
          <v-btn
            color="green"
            text
            @click.stop="apply()"
          >
            {{ lang.historic.filters.apply }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import daterange from '@/components/utils/daterange/mixins'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import defaults from '@/mixins/defaults/filters'

export default {
  mixins: [ appdata, utils, daterange ],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialog: false,
      filters: { ...this.value }
    }
  },
  methods: {
    reset () {
      this.filters = { ...defaults.financial.cashflow }
    },
    apply () {
      this.$emit('input', { ...this.filters })
      this.dialog = false
    }
  }
}
</script>

<style scoped>
#app .v-dialog > .v-card > .v-card__text {
  padding: 0px 9px 0px 9px;
}
#app .filters-content {
  padding: 0px !important;
}
</style>
